type PayPalLoadErrorType = { code: unknown; message: string; stack: string };
export const isNetworkError = (error: unknown): boolean => {
	if (!navigator.onLine) return true;
	if (error instanceof TypeError) {
		return ['Failed to fetch', 'Network request failed', 'Load failed'].some((msg) =>
			(error as TypeError).message.includes(msg)
		);
	}
	if ((error as PayPalLoadErrorType)?.message === 'Failed to fetch') return true;

	return false;
};

export const isAbortNavigation = (e: unknown): boolean =>
	e instanceof Error && e.message === 'ABORT_NAVIGATION';
